import { render } from "./Avatar.vue?vue&type=template&id=8633ba96"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Avatar.vue?vue&type=style&index=0&id=8633ba96&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script